import type { CSSProperties } from 'react';

import { FigcaptionWrapper } from '../../imageBlock/FigcaptionWrapper';

interface Props {
  asLink: boolean;
  articleThumbnailSrc: string;
  asFullWidth?: boolean;
  articleLink?: string;
  articleTitle?: string;
  /** Combined caption/credit HTML; omit when null/undefined/empty. */
  captionHtml?: string | null;
  /** Column-based font-size override on top of Image Source theme vars. */
  captionFontSizeStyle?: CSSProperties;
}

export const Thumbnail = ({
  asLink,
  articleLink,
  articleThumbnailSrc,
  articleTitle,
  asFullWidth = false,
  captionHtml,
  captionFontSizeStyle,
}: Props) => {
  const imageClassName = asFullWidth ? 'w-full h-auto object-cover' : 'w-full h-auto object-cover';

  const image = asLink ? (
    <a href={articleLink} target="_blank" rel="noreferrer" data-skip-tracking="true" className="block w-full">
      <img src={articleThumbnailSrc} alt={articleTitle} className={imageClassName} />
    </a>
  ) : (
    <img src={articleThumbnailSrc} alt={articleTitle} className={imageClassName} />
  );

  if (!captionHtml) {
    return image;
  }

  return (
    <div className="flex w-full flex-col">
      {image}
      <FigcaptionWrapper className="w-full" style={captionFontSizeStyle}>
        <span dangerouslySetInnerHTML={{ __html: captionHtml }} />
      </FigcaptionWrapper>
    </div>
  );
};
